var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayeredSquaresIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1667 10.3332V1.83317H4.66675V10.3332H13.1667ZM14.5834 10.3332C14.5834 10.7089 14.4342 11.0692 14.1685 11.3349C13.9028 11.6006 13.5425 11.7498 13.1667 11.7498H4.66675C4.29103 11.7498 3.93069 11.6006 3.66501 11.3349C3.39934 11.0692 3.25008 10.7089 3.25008 10.3332V1.83317C3.25008 1.04692 3.8805 0.416504 4.66675 0.416504H13.1667C13.5425 0.416504 13.9028 0.565759 14.1685 0.831436C14.4342 1.09711 14.5834 1.45745 14.5834 1.83317V10.3332ZM10.3334 13.1665V14.5832H1.83341C1.45769 14.5832 1.09736 14.4339 0.83168 14.1682C0.566004 13.9026 0.416748 13.5422 0.416748 13.1665V3.95817H1.83341V13.1665H10.3334Z",
    fill: "#7CBE7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayeredSquaresIcon);
export default __webpack_public_path__ + "static/media/layered-squares-icon.4629202b7096abc2855b7ebfad6b9c79.svg";
export { ForwardRef as ReactComponent };